export function redirectIfNeeded() {
  if (window.location.hostname === 'manage.reliancetelephone.com') {
    window.location.href = 'https://www.reliancetelephone.com' + window.location.pathname + window.location.search;
  }
}
